var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BitConditonLogic } from './bit-condition-logic';
import { OptionItem } from '../../../../diagram/utils/option-item';
var BitConditionTypeOptionService = /** @class */ (function () {
    function BitConditionTypeOptionService() {
        this.optionList = [
            new OptionItem(BitConditonLogic.On, 'ON'),
            new OptionItem(BitConditonLogic.Off, 'OFF')
        ];
    }
    BitConditionTypeOptionService.prototype.getOptions = function () {
        return this.optionList;
    };
    BitConditionTypeOptionService.prototype.getOptionNameByKey = function (key) {
        // eslint-disable-next-line eqeqeq
        var option = _.find(this.optionList, function (s) { return s.key == key; });
        return option ? option.name : '';
    };
    BitConditionTypeOptionService = __decorate([
        Injectable()
    ], BitConditionTypeOptionService);
    return BitConditionTypeOptionService;
}());
export { BitConditionTypeOptionService };
